import { Box } from '@mui/material'
import { EthAddress } from '@xylabs/sdk-js'
import { EthAccountButton, QuickTipButton, TokenAmount } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { XyoWorldMinterEvents } from '@xyo-network/world-typechain'

import { parseBigNumber } from '../../../parseBigNumber'
import GeotokenIdentification from '../../GeotokenIdentification'
import EventStringFragment from './EventStringFragment'

interface RefundedCurrentBidEventProps {
  event: XyoWorldMinterEvents.RefundedCurrentBid
}

const RefundedCurrentBidEventCard: React.FC<RefundedCurrentBidEventProps> = (props) => {
  const { event } = props
  const { to, id, amount } = event.args

  const version = !!to && !id && !amount ? 1 : 3

  const quadkey = Quadkey.fromBase10String(id.toString())
  const address = EthAddress.fromString(to.toString())
  const amountBN = parseBigNumber(amount)

  return (
    <Box alignItems="center" display="flex" flexWrap="wrap">
      <EthAccountButton variant="outlined" address={address} addressLength="auto" />
      <EventStringFragment>received a refund of</EventStringFragment>
      <TokenAmount amount={amountBN} />
      <EventStringFragment>from previous bid for</EventStringFragment>
      <GeotokenIdentification icon={false} quadkey={quadkey} />
      {version === 1 ? (
        <QuickTipButton title="Smart Contract Bug">
          Due to a bug in the XyoWorldMinter 1.0 Smart Contract, this event always emits 0x0000000000000000000000000000000000000000 for the
          &pos;to&pos; address.
        </QuickTipButton>
      ) : null}
    </Box>
  )
}

export default RefundedCurrentBidEventCard
